import { PageMeta } from '../components/PageMeta';
import { Btn, Container, Eyebrow } from '../site/primitives';
import { AstronautArt } from '../site/sections';
import { ART } from '../site/media';

export function NotFoundPage() {
  return (
    <>
      <PageMeta title="Page not found" description="The requested Enshield page could not be found." noIndex />
      <section data-motion="hero-scene" className="p-hero p-hero--center p-hero--notfound" aria-labelledby="notfound-title">
        <Container width="read">
          <div className="p-hero__copy">
            <AstronautArt {...ART.magnifier} support drift priority />
            <Eyebrow pill>Error 404</Eyebrow>
            <h1 id="notfound-title" className="u-h1">This page doesn’t exist</h1>
            <p className="u-lead">
              The page may have moved, or the address may be incomplete. Here’s where most people are heading.
            </p>
            <div className="u-cluster u-cluster--center p-hero__actions">
              <Btn to="/">Back to home</Btn>
              <Btn tone="secondary" to="/contact">Contact support</Btn>
            </div>
            <nav className="p-chips" aria-label="Popular pages">
              <Btn tone="ghost" to="/track-claim">Track a claim</Btn>
              <Btn tone="ghost" to="/file-a-claim">File a claim</Btn>
              <Btn tone="ghost" to="/faq">FAQ</Btn>
              <Btn tone="ghost" to="/claims-center">Claims Center</Btn>
            </nav>
          </div>
        </Container>
      </section>
    </>
  );
}
